import script from "./OrderCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderCard.vue?vue&type=script&setup=true&lang=ts"

import "./OrderCard.vue?vue&type=style&index=0&id=49edb924&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49edb924"]])

export default __exports__